import { getPurchasePlanList, createPurchasePlan, updatePurchasePlan, deletePurchasePlan } from '@/api/purchase'

const state = {
  planList: [],
  planTotal: 0,
  currentPlan: null
}

const mutations = {
  SET_PLAN_LIST: (state, { list, total }) => {
    state.planList = list
    state.planTotal = total
  },
  SET_CURRENT_PLAN: (state, plan) => {
    state.currentPlan = plan
  }
}

const actions = {
  // 获取采购计划列表
  getPlanList({ commit }, query) {
    return new Promise((resolve, reject) => {
      getPurchasePlanList(query).then(response => {
        const { items, total } = response.data
        commit('SET_PLAN_LIST', { list: items, total })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 创建采购计划
  createPlan({ commit }, planData) {
    return new Promise((resolve, reject) => {
      createPurchasePlan(planData).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 更新采购计划
  updatePlan({ commit }, planData) {
    return new Promise((resolve, reject) => {
      updatePurchasePlan(planData).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 删除采购计划
  deletePlan({ commit }, planId) {
    return new Promise((resolve, reject) => {
      deletePurchasePlan(planId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 